<template>
  <Dropdown class="mr-3">
    <template v-slot:default="{ contentVisible }">
      <button
        aria-label="notifications"
        class="no-style"
        :aria-expanded="contentVisible ? 'true' : 'false'"
      >
        <feather-icon icon="BellIcon" class="cursor-pointer mt-1" :badge="numUnreadNotifications" />
      </button>
    </template>
    <template v-slot:content>
      <div class="notification-content">
        <div class="notification-top text-center p-3 bg-primary text-white rounded-t-sm">
          <p>App Notifications</p>
        </div>
        <p class="m-2 text-center" v-if="notifications.length == 0">No notifications found</p>

        <ul v-if="notifications.length" class="bordered-items">
          <li
            v-for="ntf in notifications"
            :key="ntf.id"
            role="button"
            tabindex="0"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
            @click="getOnclickNotification(ntf.onclick_route)"
            @keydown.enter.prevent="getOnclickNotification(ntf.onclick_route)"
            @keydown.space.prevent="getOnclickNotification(ntf.onclick_route)"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="ntf.icon"
                :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"
              ></feather-icon>
              <div class="mx-2">
                <span
                  class="font-medium block notification-title"
                  :class="[`text-${ntf.category}`]"
                  >{{ ntf.data.title }}</span
                >
                <small>{{ ntf.data.text }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created_at) }}</small>
          </li>
        </ul>

        <div class="flex justify-center my-2">
          <button role="link" class="no-style" @click="viewNotifications">
            <span>See All Notifications</span>
          </button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';
import Dropdown from './Dropdown';

export default {
  components: {
    Dropdown,
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    notifications() {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        let notifications = store.getters['authStudent/notifications'];
        if (notifications.length > 10) return notifications.slice(0, 10);
        return notifications;
      } else if (login_type == 'teacher') {
        let notifications = store.getters['authTeacher/notifications'];
        if (notifications.length > 10) return notifications.slice(0, 10);
        return notifications;
      } else return [];
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      markingNotificationsRead: false,
      numUnreadNotifications: 0,
    };
  },
  methods: {
    elapsedTime(startTime) {
      const x = new Date(startTime);
      const now = new Date();
      let timeDiff = now - x;
      timeDiff /= 1000;

      const seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      const minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      const hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      const days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      const years = timeDiff;

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`;
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`;
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`;
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`;
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now');
      }

      return 'Just Now';
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      const date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
    markNotificationsRead() {
      if (this.numUnreadNotifications > 0 && !this.markingNotificationsRead) {
        this.markingNotificationsRead = true;
        const login_type = localStorage.getItem('login_type');
        if (login_type == 'student')
          store.dispatch('authStudent/markLastNotificationsRead', this.numUnreadNotifications);
        else if (login_type == 'teacher')
          store.dispatch('authTeacher/markLastNotificationsRead', this.numUnreadNotifications);
        this.markingNotificationsRead = false;
      }
    },
    getOnclickNotification(onclick_route) {
      if (onclick_route !== null) {
        router.push(onclick_route);
      }
    },
    viewNotifications() {
      const login_type = localStorage.getItem('login_type');
      router.push('/' + login_type + '/notifications');
    },
  },
  mounted() {
    let numUnread = 0;
    this.notifications.forEach((notification) => {
      if (notification.is_read == 0) numUnread++;
    });
    this.numUnreadNotifications = numUnread;
  },
  watch: {
    notifications() {
      let numUnread = 0;
      this.notifications.forEach((notification) => {
        if (notification.is_read == 0) numUnread++;
      });
      this.numUnreadNotifications = numUnread;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-content {
  width: 350px;
}
</style>
